module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.bbc0e580.svg";